import { ASSET_TYPE } from "./rrdConstants";
import { normalizeRRDAssetType } from "./rrdLayoutHelper";

type RRDAsset = Record<string, any>;
type RRDSlot = Record<string, any>;

export function canAssignAssetToRRDSlot(
  asset?: RRDAsset | null,
  slot?: RRDSlot | null
) {
  if (!asset || !slot || slot.locked || slot.editable === false) return false;

  const sourceType = normalizeRRDAssetType(asset.asset_type || asset.assetType);
  const targetType = normalizeRRDAssetType(slot.assetType || slot.type);

  return sourceType === targetType;
}

export function isRRDHeroLikeAssetType(assetType?: string | null) {
  const normalizedType = normalizeRRDAssetType(assetType);
  return [
    ASSET_TYPE.HERO,
    ASSET_TYPE.LARGE_HERO,
    ASSET_TYPE.MEDIUM_HERO,
  ].includes(normalizedType);
}

function valuesMatch(left: unknown, right: unknown) {
  if (
    left === undefined ||
    left === null ||
    right === undefined ||
    right === null
  )
    return false;
  return String(left) === String(right);
}

function slotMatchesSelectedAsset(
  asset?: RRDAsset | null,
  slot?: RRDSlot | null
) {
  if (!asset || !slot) return false;
  if (valuesMatch(asset.slotId, slot.id)) return true;
  if (valuesMatch(asset.slot_id, slot.id)) return true;
  if (valuesMatch(asset.order, slot.order)) return true;
  if (valuesMatch(asset.coupon_number, slot.order)) return true;
  if (valuesMatch(asset.couponNumber, slot.order)) return true;

  const slotType = normalizeRRDAssetType(slot.assetType);
  if (slotType === ASSET_TYPE.COUPON) return false;

  if (slot.side && asset.side === slot.side) {
    const assetType = normalizeRRDAssetType(
      asset.asset_type || asset.assetType
    );
    return !assetType || assetType === slotType;
  }
  return false;
}

export function assignAssetToRRDSlot(
  selectedAssets: RRDAsset[] = [],
  asset?: RRDAsset | null,
  slot?: RRDSlot | null
) {
  if (!canAssignAssetToRRDSlot(asset, slot)) return selectedAssets;

  const assetType = normalizeRRDAssetType(asset.asset_type || asset.assetType);
  const updatedAssets = selectedAssets.filter(
    (selectedAsset) => !slotMatchesSelectedAsset(selectedAsset, slot)
  );

  return [
    ...updatedAssets,
    {
      ...asset,
      side: slot.side,
      order: slot.order,
      coupon_number: slot.order,
      couponNumber: slot.order,
      slotId: slot.id,
      slot_id: slot.id,
      asset_type: assetType,
      assetType,
    },
  ];
}

export function removeAssetFromRRDSlot(
  selectedAssets: RRDAsset[] = [],
  slotOrSide?: RRDSlot | string | null
) {
  const slot =
    typeof slotOrSide === "string" ? { side: slotOrSide } : slotOrSide || {};
  return selectedAssets.filter(
    (selectedAsset) => !slotMatchesSelectedAsset(selectedAsset, slot)
  );
}
